module.exports = __webpack_public_path__ + "static/hero2-453bce78e1318a333ffb1ac3187e9ab6.png";